<dx-load-panel #loadPanel
               shadingColor="rgba(0,0,0,0.4)"
               [visible]="loadPanelVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false">
</dx-load-panel>

<!--dialogService.spinner===true-->
<!--
[position]="{ of: '#employee' }"
               (onShown)="onShown()"
               (onHidden)="onHidden()"
-->
